import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=e67fb2f6&"
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e67fb2f6')) {
      api.createRecord('e67fb2f6', component.options)
    } else {
      api.reload('e67fb2f6', component.options)
    }
    module.hot.accept("./Logout.vue?vue&type=template&id=e67fb2f6&", function () {
      api.rerender('e67fb2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Logout/Logout.vue"
export default component.exports